import { type ReactNode, useEffect } from 'react'
import { NotReady } from '@components'
import { useAuthSession } from '@util'
import { createFileRoute } from '@tanstack/react-router'

function Logout(): ReactNode {
  const { isAuthenticated, isLoading, signOut } = useAuthSession()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      signOut()
    }
  }, [isLoading, isAuthenticated, signOut])

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      window.location.href = '/'
    }
  }, [isLoading, isAuthenticated])

  return <NotReady isLoading />
}

export const Route = createFileRoute('/logout/')({
  component: Logout,
})
